import { openBlock as o, createElementBlock as t, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 20"
};
function l(s, e) {
  return o(), t("svg", n, [...e[0] || (e[0] = [
    r("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M3.452 7C4.65 9.266 7.132 10.823 10 10.823S15.351 9.266 16.55 7M4.77 8.741 2 11.102m6.05-.52L6.718 14m8.513-5.259L18 11.102m-6.055-.52L13.277 14"
    }, null, -1)
  ])]);
}
const i = { render: l };
export {
  i as default,
  l as render
};
